module.exports = __webpack_public_path__ + "img/img4.214ebc2a.png";